module.exports = __webpack_public_path__ + "static/media/fire-smoke.b56baae9.svg";